function showHide_perezvon(element_id) {
    $(".phone_mask_perezvon").inputmask("(999) 999-99-99");
    //Если элемент с id-шником element_id существует
    if (document.getElementById(element_id)) {
        //alert("id: " + element_id + "");
        //Записываем ссылку на элемент в переменную obj
        var obj = document.getElementById(element_id);
        //Если css-свойство display не block, то:
        if (obj.style.display != "block") {
            obj.style.display = "block"; //Показываем элемент
            //alert("Элемент с id: " + element_id + " Показываем элемент!");
        } else
            obj.style.display = "none"; //Скрываем элемент
    }
    //Если элемент с id-шником element_id не найден, то выводим сообщение
    else
        alert("Элемент с id: " + element_id + " не найден!");
}

$(document).ready(function () {

    $('div.button-widget_perezvon').on('click', function () {
        const url_patch = document.location.pathname;
        // Список комерческого транспорта
        let list_comtrans_url = [
            "/remont-kommercheskogo-transporta/",
            "/euro/citroen/berlingo/",
            "/euro/vw/caddy/",
            "/euro/vw/caravelle/",
            "/euro/renault/espace/",
            "/euro/vw/multivan/",
            "/euro/ford-euro/galaxy/",
            "/euro/peugeot/partner/",
            "/euro/citroen/space-tourer/",
            "/kor/kia/carnival/",
            "/euro/vw/transporter/",
            "/euro/peugeot/traveller/",
            "/euro/mercedes/v-klasse/",
            "/kor/hyundai/hd/",
            "/euro/seat/alhambra/",
            "/jp/toyota/alphard/",
            "/euro/peugeot/boxer/",
            "/euro/opel/combo/",
            "/euro/vw/crafter/",
            "/euro/fiat/doblo/",
            "/euro/renault/dokker/",
            "/euro/fiat/ducato/",
            "/jp/honda/elysion/",
            "/euro/peugeot/expert/",
            "/usa/chevrolet/express/",
            "/jp/toyota/hiace/",
            "/jp/daihatsu/hijet/",
            "/euro/citroen/jumper/",
            "/euro/citroen/jumpy/",
            "/euro/renault/kangoo/",
            "/euro/vw/lt/",
            "/euro/renault/master/",
            "/jp/honda/odyssey/",
            "/usa/chrysler/pacifica/",
            "/euro/mercedes/r-klasse/",
            "/jp/nissan/serena/",
            "/euro/mercedes/sprinter/",
            "/euro/mercedes/sprinter-classic/",
            "/euro/vw/touran/",
            "/jp/toyota/townace/",
            "/euro/renault/trafic/",
            "/euro/mercedes/viano/",
            "/euro/mercedes/vito/",
            "/euro/opel/vivaro/",
            "/kor/hyundai/porter/",
            "/kor/hyundai/starex/",
            "/euro/ford-euro/tourneo/",
            "/euro/ford-euro/transit/",
            "/euro/ford-euro/transit-custom/",
        ];


        // let q800334 = document.getElementById("sevPrint3").innerHTML;
        // q800334 = q800334.replace("<div>", "");
        // q800334 = q800334.replace("</div>", "");
        // q800334 = q800334.replace("<span>", "");
        // q800334 = q800334.replace("</span>", "");
        //
        // console.log('***' + q800334 + '***');

        let phonezrr = $("#phoneperezvon").val();
        let t = +new Date() + 10000;

        if (phonezrr.length < 7 || /^[\+]?\d?[ ]?[\(]?\d{3}[\)]?[ ]?\d{2,3}[- ]?\d{2}[- ]?\d{2}$/gi.test(phonezrr) == false) {
            $('#phoneperezvon').css('border', '1px solid rgb(255 247 0)');
            $('#phoneperezvon').css('border-radius', '5px');
            return;
        }
        if (phonezrr.length > 6) {
            $(this).html('Отправка...');
            if (window.ComagicWidget) {
                if (url_patch && list_comtrans_url.includes(url_patch)) {
                    // Звонок на номер 74994954438 - комтранс Лобня (код группы 368139)
                    console.log('comtrans')
                    ComagicWidget.sitePhoneCall({
                        phone: '+7' + phonezrr,
                        group_id: '406026',
                        delayed_call_time: t.toString()
                    });
                    sendDataToServer('lobnya', '+7' + phonezrr, 'red_phone');
                } else {
                    // Звонок на номер севак (код группы 206505)
                    // Звонок на номер Лобня (код группы 206503)
                    // var id_ploshadki = '206505'; // sev
                    var id_ploshadki = '206503'; // lob

                    if (phonezrr === '(000) 000-00-00') {
                        console.log('nen');
                        console.log(phonezrr);
                        console.log(id_ploshadki);

                    } else {
                        // let tel = document.getElementById("lbn").innerHTML;
                        // tel = tel.replace(/[^\d]/g, '');
                        // if (tel === '84994954327') {
                        //     id_ploshadki = '406026';
                        // } else if (tel === '74994951063') {
                        //     id_ploshadki = '383523'
                        // } else {
                        //     id_ploshadki = '368139';
                        // }
                        console.log("-----red------")
                        console.log(id_ploshadki);
                        // console.log(tel)
                        console.log("-----------")
                        ComagicWidget.sitePhoneCall({
                            phone: '+7' + phonezrr,
                            group_id: id_ploshadki,
                            delayed_call_time: t.toString()
                        });
                        // sendDataToServer('lobnya', '+7' + phonezrr, 'red_phone');
                        sendDataToServer('sevastopol', '+7' + phonezrr, 'red_phone');
                    }
                }
            }
            yaCounter7501828.reachGoal('red_call_back');
            yaCounter7501828.reachGoal('mango');
            Modal.show('#success_send_popup');
            showHide_perezvon('perethvon0');
            showHide_perezvon('perethvon');
            $('.button-widget_perezvon').html('Отправлено');
            $('#phoneperezvon').remove();
            // $.post("/ajax/send.php",
            //     {
            //         phone: '7' + phonezrr,
            //         action: 'mango'
            //     },
            //     function (e) {
            //         console.log('Письмо отправлено: ' + e)
            //     }
            // );

            // $(this).html('Отправка...');
            // $.post("/ajax/send.php",
            //         {
            //             phone: '7' + phonezrr,
            //             action: 'mango'
            //         },
            //         function (data111s22122ddd2111) {
            //
            //             /*
            //              if (window.ComagicWidget) {
            //              var t = +new Date () + 10000;
            //              alert(phonezrr);//
            //              yaCounter7501828.reachGoal('mango');
            //              ComagicWidget.sitePhoneCall({phone:phonezrr, group_id: id_ploshadki, delayed_call_time: t.toString()});
            //              }
            //              var array_of_dealers_for_comagic = new Array();
            //              array_of_dealers_for_comagic['sevastopolskoy'] = 205833;
            //              array_of_dealers_for_comagic['koluzshskaya'] = 205827;
            //              array_of_dealers_for_comagic['dmitrovka'] = 205825;
            //              array_of_dealers_for_comagic['nizhegorod'] = 205831;
            //              array_of_dealers_for_comagic['michurinskiy'] = 205829;*/
            //
            //             if (window.ComagicWidget) {
            //                 // Получаем ID группы comagic из admin.qrenta.ru
            //                 let phone_number = q800334.replace(/[^\d]/g, '');
            //                 var t = +new Date() + 10000;
            //                 var settings = {
            //                     "url": "https://admin.qrenta.ru/api/sitephone/code_perezvon?phone=" + phone_number + "&site=1",
            //                     "method": "GET",
            //                     "timeout": 0,
            //                 };
            //                 $.ajax(settings).done(function (response) {
            //                     var id_ploshadki = "206505"; // По дефолту ставим Севак, если код не получен по какой либо причине
            //                     if(response['status']){
            //                         id_ploshadki = response['data']['code_perezvon'];
            //                     }
            //                     ComagicWidget.sitePhoneCall({phone: phonezrr, group_id: id_ploshadki, delayed_call_time: t.toString()});
            //                     //ComagicWidget.sitePhoneCall({phone: phonezrr, delayed_call_time: t.toString(), group_id: selected_location});
            //                 });
            //                 //var t = +new Date() + 10000;
            //                 //var selected_location =205833; //array_of_dealers_for_comagic[ $('select[name=dealer]').val() ];
            //                 //ComagicWidget.sitePhoneCall({phone: phonezrr, delayed_call_time: t.toString(), group_id: selected_location});
            //             }
            //             //yaCounter7501828.reachGoal('mango');
            //             //alert('Отправлено');
            //             //Modal.show($('#success'));
            //             yaCounter7501828.reachGoal('mango');
            //             Modal.show('#success_send_popup');
            //             showHide_perezvon('perethvon0');
            //             showHide_perezvon('perethvon');
            //             $('.button-widget_perezvon').html('Отправлено');
            //             $('#phoneperezvon').remove();
            //         }
            // );
        }
    });
    /* перезвонишка2 конец*/
});
